export function replacePlaceholder(
  value: string,
  placeholder: string,
  opt: string
) {
  const replaceFunction = () => opt;
  return value.replace(
    new RegExp(
      `{{${placeholder}}}|__${placeholder}__|_{${placeholder}}_|#{${placeholder}}`,
      'g'
    ),
    replaceFunction
  );
}

export function replacePlaceholders(
  value: string,
  opts?: {
    [key: string]: string;
  }
) {
  if (opts && typeof opts === 'object') {
    Object.keys(opts).forEach(placeholder => {
      if (opts && opts.hasOwnProperty(placeholder)) {
        value = replacePlaceholder(value, placeholder, opts[placeholder]);
      }
    });
  }
  return value;
}
